import { BrandclubEventType, TrackingPixel } from "./types";

let debug = false;
let initialized = false;
let loaderScript: HTMLScriptElement | null = null;
let initScript: HTMLScriptElement | null = null;

const PROVIDER = 'TheTradeDesk';

const log = (...args: any[]) => {
  if (!debug) {
    return;
  }
  // eslint-disable-next-line no-console
  console.info(...['[TTD]'].concat(args));
};

function initializeTDDPixel(brandId: string, pixelLoadUrl: string, initArgs: string[]) {
  if (!initialized && brandId && pixelLoadUrl && initArgs) {
    initialized = true;
    loaderScript = document.createElement('script');
    loaderScript.type = 'text/javascript';
    loaderScript.src = pixelLoadUrl;
    document.body.appendChild(loaderScript);
    loaderScript.onload = () => {
      log('initializeTDDPixel', brandId, pixelLoadUrl, initArgs);
      initScript = document.createElement('script');
      initScript.type = 'text/javascript';
      initScript.innerHTML = `ttd_dom_ready(function() {
            if (typeof TTDUniversalPixelApi === 'function') {
            var universalPixelApi = new TTDUniversalPixelApi();
            universalPixelApi.init(
                ${JSON.stringify(initArgs[0])},
                ${JSON.stringify(initArgs[1])},
                ${JSON.stringify(initArgs[2])}
            );
        }});`;
      document.body.appendChild(initScript);
    };
  }
}

const tddPixel = {
  enableDebug() {
    debug = true;
  },
  track({ brandId, pixels, eventName, eventType, eventPayload }: {
    brandId: string;
    pixels: TrackingPixel[];
    eventName: string;
    eventType: BrandclubEventType;
    eventPayload: any;
  }) {
    const pixel = pixels?.find((item) => item.pixelProvider === PROVIDER);
    if (!pixel) {
      return;
    }
    log(JSON.stringify({ brandId, pixels, eventName, payload: eventPayload }));
    initializeTDDPixel(brandId, pixel?.pixelLoadUrl, pixel?.pixelInitArgs ? JSON.parse(pixel.pixelInitArgs) : []);

    if (eventType === BrandclubEventType.PageView) {
      initializeTDDPixel(brandId, pixel?.pixelLoadUrl, pixel?.pixelInitArgs ? JSON.parse(pixel.pixelInitArgs) : []);
    } else if (eventType === BrandclubEventType.OrderSubmitted || eventType === BrandclubEventType.AddToCart) {
      initializeTDDPixel(brandId, pixel?.pixelLoadUrl, pixel?.pixelInitArgs ? JSON.parse(pixel.pixelInitArgs) : []);
    }
  },
};

export default tddPixel;
